// extracted by mini-css-extract-plugin
export var dark = "styles-module--dark--82bcc";
export var fadeLeft = "styles-module--fadeLeft--18e7c";
export var fadeRight = "styles-module--fadeRight--a1da1";
export var fades = "styles-module--fades--f15c8";
export var items = "styles-module--items--c108d";
export var light = "styles-module--light--24eb8";
export var motion = "styles-module--motion--d5c81";
export var panel = "styles-module--panel--4fd86";
export var title = "styles-module--title--066d0";
export var wrapper = "styles-module--wrapper--d9e74";